import { render, staticRenderFns } from "./activeReports.vue?vue&type=template&id=13f96df2&scoped=true"
import script from "./activeReports.vue?vue&type=script&lang=js"
export * from "./activeReports.vue?vue&type=script&lang=js"
import style0 from "./activeReports.vue?vue&type=style&index=0&id=13f96df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f96df2",
  null
  
)

export default component.exports